import { render, staticRenderFns } from "./RelatorioFinal.vue?vue&type=template&id=4fdabd00&scoped=true"
import script from "./RelatorioFinal.vue?vue&type=script&lang=js"
export * from "./RelatorioFinal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioFinal.vue?vue&type=style&index=0&id=4fdabd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdabd00",
  null
  
)

export default component.exports